export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-geo/src/noop.js
// module id = 20
// module chunks = 0